/** Tiny synthesized sound effects (Web Audio): no audio assets, nothing to license. */
let ctx: AudioContext | null = null;

function audio(): AudioContext | null {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch {
    return null;
  }
}

function tone(
  freqFrom: number,
  freqTo: number,
  ms: number,
  volume: number,
  type: OscillatorType = 'sine',
): void {
  const ac = audio();
  if (!ac || volume <= 0) return;
  const osc = ac.createOscillator();
  const gain = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freqFrom, ac.currentTime);
  osc.frequency.exponentialRampToValueAtTime(freqTo, ac.currentTime + ms / 1000);
  gain.gain.setValueAtTime(volume * 0.25, ac.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + ms / 1000);
  osc.connect(gain).connect(ac.destination);
  osc.start();
  osc.stop(ac.currentTime + ms / 1000);
}

export const sfx = {
  spin: (v: number) => tone(180, 520, 900, v, 'triangle'),
  kiss: (v: number) => {
    tone(900, 300, 120, v, 'square');
    setTimeout(() => tone(1200, 400, 90, v, 'square'), 90);
  },
  refuse: (v: number) => tone(300, 140, 260, v, 'sawtooth'),
  turn: (v: number) => tone(660, 990, 220, v),
  message: (v: number) => tone(880, 880, 60, v * 0.6),
  /** A domino tile laid on the table. */
  tile: (v: number) => {
    tone(1400, 900, 45, v * 0.8, 'triangle');
    setTimeout(() => tone(700, 500, 60, v * 0.5, 'triangle'), 35);
  },
  /** Incoming call: a two-note chime, twice. */
  ring: (v: number) => {
    for (const [i, f] of [988, 784, 988, 784].entries()) setTimeout(() => tone(f, f, 260, v), i * 300);
  },
  /** Outgoing call: the long tone of a ringing line. */
  ringback: (v: number) => tone(425, 425, 1100, v * 0.5),
};
